import styled from 'styled-components';

export const TableRowHeader = styled.tr`
  vertical-align: middle;
  height: 90px;
`;
